import React, { useRef, useEffect, useState } from 'react';
import {TextField} from '@mui/material';
import loadGoogleMapsApi from 'load-google-maps-api';
import {GOOGLE_API_kEY} from "../../lib/constants/constants";

const LocationAutocomplete = ({ label, onPlaceSelected, value }) => {
   const inputRef = useRef(null);
   const [inputValue, setInputValue] = useState('');
   const [shouldLoadAutocomplete, setShouldLoadAutocomplete] = useState(false);

// Update input value when value prop changes
   useEffect(() => {
      if (value) {
         // Handle both formatted objects and location strings
         if (value.formatted_address) {
            setInputValue(value.formatted_address);
         } else if (typeof value === 'string') {
            setInputValue(value);
         } else if (value.address) {
            // Handle location objects with address property
            setInputValue(value.address);
         }
      }
   }, [value]);
   
   // Initialize Google Maps Autocomplete
   useEffect(() => {
      if (shouldLoadAutocomplete) {
         loadGoogleMapsApi({
            key: GOOGLE_API_kEY,
            libraries: ['places'],
         }).then((googleMaps) => {
            const autocompleteInstance = new googleMaps.places.Autocomplete(inputRef.current, {
               types: ['geocode'],
            });
            autocompleteInstance.addListener('place_changed', () => {
               const place = autocompleteInstance.getPlace();
               if (place.geometry) {
                  onPlaceSelected(place);
                  setInputValue(place.formatted_address);
               }
            });
         }).catch(error => {
            console.error("Error loading Google Maps:", error);
         });
      }
   }, [shouldLoadAutocomplete, onPlaceSelected]);
   const handleInputChange = (e) => {
      const value = e.target.value;
      setInputValue(value);

      if (value.includes(' ') && /\d/.test(value.split(' ')[0])) {
         if (!shouldLoadAutocomplete) {
            setShouldLoadAutocomplete(true);
         }
      } else {
         if (shouldLoadAutocomplete) {
            setShouldLoadAutocomplete(false);
         }
      }
   };
   return (
      <>
         <TextField
            fullWidth
            label={label}
            value={inputValue}
            onChange={handleInputChange}
            margin="normal"
            inputRef={inputRef}
            helperText={inputValue && !shouldLoadAutocomplete ? 'Please enter a street number followed by a space.' : ''}
         />
      </>
   );
};

export default LocationAutocomplete;
